// extracted by mini-css-extract-plugin
export default {"thumb":"grid-animated-sticker-item-module__thumb--b_gOp","tagContainer":"grid-animated-sticker-item-module__tagContainer--UpZH_"};